import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './index.css';
import App from './App';
import PrivacyPolicy from './PrivacyPolicy';
import RemediesPage from './RemediesPage';
import NapStore from './NapStore';
import { LanguageProvider } from './context/LanguageContext';
import reportWebVitals from './reportWebVitals';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

function NotFound() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-warm)',
        fontFamily: "'Inter', sans-serif",
        textAlign: 'center',
        padding: '2rem',
      }}
    >
      <div style={{ fontSize: '5rem', marginBottom: '1rem' }}>🌸</div>
      <h1
        style={{
          fontFamily: "'Playfair Display', serif",
          color: 'var(--text-deep)',
          fontSize: '2.5rem',
          marginBottom: '0.5rem',
        }}
      >
        Page Not Found
      </h1>
      <p style={{ color: '#6b7280', marginBottom: '2rem', maxWidth: '400px' }}>
        Looks like this page doesn't exist. Let's get you back to your beauty routine!
      </p>
      <a
        href="/"
        style={{
          background: 'linear-gradient(135deg, #c2185b, #ec4899)',
          color: 'white',
          padding: '0.875rem 2rem',
          borderRadius: '0.75rem',
          fontWeight: '600',
          textDecoration: 'none',
          boxShadow: '0 4px 15px rgba(194,24,91,0.35)',
        }}
      >
        Back to Home
      </a>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/remedies" element={<RemediesPage />} />
          <Route path="/nap-store" element={<NapStore />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </LanguageProvider>
  </React.StrictMode>
);

reportWebVitals();